import { i18nLangToThemeLocale } from './languageConstants';

function resolveThemeLocale(lang) {
  if (lang === 'eng' || lang === 'kor') return lang;
  return i18nLangToThemeLocale(lang);
}

/** 협력 기관 캐러셀 — title/titleEn, sites[].name/nameEn */
export function localizeRelatedSitesPayload(raw, lang) {
  if (!raw || typeof raw !== 'object') return raw;
  const locale = resolveThemeLocale(lang);
  const useEng = locale === 'eng';
  const sites = Array.isArray(raw.sites) ? raw.sites : [];
  return {
    ...raw,
    title: useEng && raw.titleEn ? raw.titleEn : raw.title || raw.titleEn || '',
    sites: sites.map((site) => {
      if (!site || typeof site !== 'object') return site;
      const name = useEng && site.nameEn ? site.nameEn : site.name || site.nameEn || '';
      return { ...site, name };
    }),
  };
}
